module.exports = __webpack_public_path__ + "img/globus.00276582.svg";